import { useState } from "react";
import { gold, w } from "../constants";
import { Card } from "../components";
import { initPdf, downloadExcel } from "./exportHelpers";
function DownloadModal({ onPdf, onExcel, onClose }) {
  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000 }}>
      <div style={{ background:"#fff",borderRadius:16,padding:28,width:"100%",maxWidth:360,margin:"0 16px" }}>
        <h2 style={{ fontSize:17,fontWeight:500,margin:"0 0 6px",color:"#1a1a1a" }}>Download your results</h2>
        <p style={{ fontSize:13,color:"#555",margin:"0 0 20px" }}>Choose your preferred format:</p>
        <button onClick={onPdf} style={{ width:"100%",padding:"12px",borderRadius:10,border:"none",background:"#A0845C",color:"#fff",fontSize:14,fontWeight:500,cursor:"pointer",marginBottom:10 }}>📄 Download PDF</button>
        <button onClick={onExcel} style={{ width:"100%",padding:"12px",borderRadius:10,border:"0.5px solid rgba(0,0,0,0.1)",background:"transparent",color:"#1a1a1a",fontSize:14,cursor:"pointer",marginBottom:10 }}>📊 Download Excel</button>
        <button onClick={onClose} style={{ width:"100%",padding:"10px",borderRadius:10,border:"0.5px solid rgba(0,0,0,0.1)",background:"transparent",color:"#555",fontSize:13,cursor:"pointer" }}>Cancel</button>
      </div>
    </div>
  );
}

const PLANS = {
  oneyear: {
    id:"oneyear", label:"One Year Bible", color:"#1A56DB",
    description:"Read through the entire Bible in one year — Old Testament, New Testament, Psalms, and Proverbs daily.",
    schedule: (() => {
      const readings = [
        ["Gen 1-2","Matt 1","Ps 1","Prov 1:1-6"],["Gen 3-4","Matt 2","Ps 2","Prov 1:7-9"],["Gen 5-7","Matt 3","Ps 3","Prov 1:10-19"],
        ["Gen 8-10","Matt 4","Ps 4","Prov 1:20-23"],["Gen 11-13","Matt 5:1-26","Ps 5","Prov 1:24-28"],["Gen 14-16","Matt 5:27-48","Ps 6","Prov 1:29-33"],
        ["Gen 17-18","Matt 6:1-18","Ps 7","Prov 2:1-5"],["Gen 19-20","Matt 6:19-34","Ps 8","Prov 2:6-15"],["Gen 21-23","Matt 7","Ps 9","Prov 2:16-22"],
        ["Gen 24","Matt 8:1-17","Ps 10","Prov 3:1-6"],["Gen 25-26","Matt 8:18-34","Ps 11-12","Prov 3:7-12"],["Gen 27-28","Matt 9:1-17","Ps 13-14","Prov 3:13-15"],
        ["Gen 29-30","Matt 9:18-38","Ps 15","Prov 3:16-18"],["Gen 31-32","Matt 10:1-20","Ps 16","Prov 3:19-20"],["Gen 33-35","Matt 10:21-42","Ps 17","Prov 3:21-26"],
        ["Gen 36-37","Matt 11","Ps 18:1-15","Prov 3:27-32"],["Gen 38-40","Matt 12:1-21","Ps 18:16-36","Prov 3:33-35"],["Gen 41-42","Matt 12:22-50","Ps 18:37-50","Prov 4:1-6"],
        ["Gen 43-45","Matt 13:1-30","Ps 19","Prov 4:7-10"],["Gen 46-47","Matt 13:31-58","Ps 20","Prov 4:11-13"],["Gen 48-50","Matt 14:1-21","Ps 21","Prov 4:14-19"],
        ["Exod 1-3","Matt 14:22-36","Ps 22:1-18","Prov 4:20-27"],["Exod 4-6","Matt 15:1-20","Ps 22:19-31","Prov 5:1-6"],["Exod 7-8","Matt 15:21-39","Ps 23","Prov 5:7-14"],
        ["Exod 9-10","Matt 16","Ps 24","Prov 5:15-21"],["Exod 11-12","Matt 17","Ps 25","Prov 5:22-23"],["Exod 13-14","Matt 18:1-20","Ps 26-27","Prov 6:1-5"],
        ["Exod 15-16","Matt 18:21-35","Ps 28-29","Prov 6:6-11"],["Exod 17-19","Matt 19","Ps 30","Prov 6:12-15"],["Exod 20-21","Matt 20:1-16","Ps 31:1-8","Prov 6:16-19"],
      ];
      return Array.from({length:365},(_,i)=>{ const r=readings[i%readings.length]; return { day:i+1, ot:r[0], nt:r[1], ps:r[2], prov:r[3] }; });
    })(),
  },
  chronological: {
    id:"chronological", label:"Chronological Bible", color:"#057A55",
    description:"Read the Bible in the order events occurred — a powerful way to see God's story unfold.",
    schedule: (() => {
      const readings = ["Gen 1-2 (Creation)","Gen 3-5 (The Fall)","Gen 6-8 (The Flood)","Gen 9-11 (Nations)","Gen 12-14 (Abram)","Gen 15-17 (Covenant)","Gen 18-19 (Sodom)","Gen 20-22 (Isaac)","Gen 23-24 (Sarah)","Gen 25-26 (Jacob)","Gen 27-29 (Jacob's wives)","Gen 30-31 (Laban)","Gen 32-34 (Wrestling)","Gen 35-37 (Joseph)","Gen 38-40 (Egypt)","Gen 41-42 (Dreams)","Gen 43-45 (Reunion)","Gen 46-47 (In Egypt)","Gen 48-50 (Blessings)","Job 1-5 (Suffering)","Job 6-10","Job 11-16","Job 17-22","Job 23-28","Job 29-33","Job 34-38","Job 39-42 (Restored)","Exod 1-3 (Moses)","Exod 4-6 (Plagues)","Exod 7-9"];
      return Array.from({length:365},(_,i)=>({ day:i+1, reading:readings[i%readings.length] }));
    })(),
  },
  nt: {
    id:"nt", label:"New Testament in a Year", color:"#7E3AF2",
    description:"Read through all 27 books of the New Testament in one year at a gentle pace.",
    schedule: (() => {
      const books = [{book:"Matthew",chapters:28},{book:"Mark",chapters:16},{book:"Luke",chapters:24},{book:"John",chapters:21},{book:"Acts",chapters:28},{book:"Romans",chapters:16},{book:"1 Corinthians",chapters:16},{book:"2 Corinthians",chapters:13},{book:"Galatians",chapters:6},{book:"Ephesians",chapters:6},{book:"Philippians",chapters:4},{book:"Colossians",chapters:4},{book:"1 Thessalonians",chapters:5},{book:"2 Thessalonians",chapters:3},{book:"1 Timothy",chapters:6},{book:"2 Timothy",chapters:4},{book:"Titus",chapters:3},{book:"Philemon",chapters:1},{book:"Hebrews",chapters:13},{book:"James",chapters:5},{book:"1 Peter",chapters:5},{book:"2 Peter",chapters:3},{book:"1 John",chapters:5},{book:"2 John",chapters:1},{book:"3 John",chapters:1},{book:"Jude",chapters:1},{book:"Revelation",chapters:22}];
      const schedule = [];
      books.forEach(b=>{ for(let c=1;c<=b.chapters;c++) schedule.push(`${b.book} ${c}`); });
      return Array.from({length:260},(_,i)=>({ day:i+1, reading:schedule[i%schedule.length] }));
    })(),
  },
  psalms: {
    id:"psalms", label:"Psalms & Proverbs", color:"#D97706",
    description:"Read through all 150 Psalms and 31 chapters of Proverbs — perfect for daily devotional use.",
    schedule: Array.from({length:150},(_,i)=>({ day:i+1, reading:`Psalm ${i+1} · Proverbs ${(i%31)+1}` })),
  },
};

const dayOfYear = date => { const start=new Date(date.getFullYear(),0,0); return Math.floor((date-start)/86400000); };

function exportBiblePdf(planId, progress, userName) {
  const plan = PLANS[planId];
  const completed = progress?.completed||[];
  const pct = Math.round((completed.length/plan.schedule.length)*100);
  const today = dayOfYear(new Date());
  let streak=0; let d=today;
  while(completed.includes(d)){streak++;d--;}
  const p = initPdf();
  p.addHeader(`Bible Reading Plan — ${plan.label}`, userName);
  p.body(`Plan: ${plan.label}`);
  p.body(`Progress: ${completed.length} of ${plan.schedule.length} days (${pct}%)`);
  p.body(`Current streak: ${streak} days`);
  p.space(4);
  p.heading3("Completed readings");
  completed.sort((a,b)=>a-b).forEach(day => {
    const entry = plan.schedule[Math.min(day-1,plan.schedule.length-1)];
    p.body(`Day ${day}: ${entry?.reading||entry?.ot||""}`, 4);
  });
  p.addFooters();
  p.doc.save(`bible-plan-${new Date().toISOString().slice(0,10)}.pdf`);
}

function exportBibleExcel(planId, progress, userName) {
  const plan = PLANS[planId];
  const completed = progress?.completed||[];
  const data = [
    ["My Self-Management Framework — Bible Reading Plan"],
    [`Name: ${userName}`, `Plan: ${plan.label}`, `Exported: ${new Date().toLocaleDateString("en-IN")}`],
    [`Progress: ${completed.length}/${plan.schedule.length} days`],
    [],
    ["Day","Reading","Completed"],
    ...plan.schedule.map(entry=>[
      entry.day,
      entry.reading||`${entry.ot||""} | ${entry.nt||""} | ${entry.ps||""} | ${entry.prov||""}`.replace(/\s*\|\s*$/,"").trim(),
      completed.includes(entry.day)?"Yes":"No",
    ]),
  ];
  downloadExcel([{name:"Bible Reading Plan",data}],`bible-plan-${new Date().toISOString().slice(0,10)}.xlsx`);
}

function PlanView({ planId, progress, onMark, onBack, userName }) {
  const [showDownload, setShowDownload] = useState(false);
  const [viewDay, setViewDay] = useState(dayOfYear(new Date()));
  const plan = PLANS[planId];
  const today = dayOfYear(new Date());
  const completed = progress?.completed||[];
  const streak = (() => { let s=0;let d=today;while(completed.includes(d)){s++;d--;}return s; })();
  const totalDays = plan.schedule.length;
  const pct = Math.round((completed.length/totalDays)*100);
  const todayEntry = plan.schedule[Math.min(today-1,totalDays-1)];
  const viewEntry = plan.schedule[Math.min(viewDay-1,totalDays-1)];

  return (
    <div>
      {showDownload&&<DownloadModal onPdf={()=>{exportBiblePdf(planId,progress,userName||"User");setShowDownload(false);}} onExcel={()=>{exportBibleExcel(planId,progress,userName||"User");setShowDownload(false);}} onClose={()=>setShowDownload(false)} />}
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back</button>
      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16 }}>
        <div style={{ display:"flex",alignItems:"center",gap:12 }}>
          <div style={{ width:10,height:10,borderRadius:"50%",background:plan.color }} />
          <h2 style={{ fontSize:18,fontWeight:500,margin:0,color:w.text }}>{plan.label}</h2>
        </div>
        <button onClick={()=>setShowDownload(true)} style={{ padding:"6px 14px",borderRadius:8,border:`0.5px solid ${gold}`,background:"transparent",color:gold,fontSize:12,cursor:"pointer",fontWeight:500 }}>Download ↓</button>
      </div>

      <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20 }}>
        {[{label:"Completed",value:`${completed.length}/${totalDays}`},{label:"Progress",value:`${pct}%`},{label:"Streak",value:`${streak} days`}].map(s=>(
          <div key={s.label} style={{ background:w.bg2,borderRadius:8,padding:"10px 12px" }}>
            <p style={{ fontSize:11,color:w.text3,margin:"0 0 4px" }}>{s.label}</p>
            <p style={{ fontSize:16,fontWeight:500,color:plan.color,margin:0 }}>{s.value}</p>
          </div>
        ))}
      </div>

      <div style={{ height:8,background:w.bg3,borderRadius:4,marginBottom:20,overflow:"hidden" }}>
        <div style={{ height:"100%",width:`${pct}%`,background:plan.color,borderRadius:4 }} />
      </div>

      <Card style={{ border:`0.5px solid ${plan.color}40`,background:`${plan.color}08` }}>
        <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12 }}>
          <h3 style={{ fontSize:14,fontWeight:500,color:plan.color,margin:0 }}>Today — Day {today}</h3>
          {completed.includes(today)
            ? <span style={{ fontSize:12,padding:"3px 10px",background:"#eaf3de",color:"#057A55",borderRadius:20 }}>✓ Done</span>
            : <button onClick={()=>onMark(today)} style={{ fontSize:12,padding:"6px 14px",borderRadius:20,border:"none",background:plan.color,color:"#fff",cursor:"pointer",fontWeight:500 }}>Mark as read</button>
          }
        </div>
        {todayEntry&&(planId==="oneyear"
          ? <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
              {[{l:"OT",v:todayEntry.ot},{l:"NT",v:todayEntry.nt},{l:"Psalm",v:todayEntry.ps},{l:"Proverbs",v:todayEntry.prov}].map(r=><div key={r.l} style={{ display:"flex",gap:8 }}><span style={{ fontSize:12,color:plan.color,fontWeight:500,minWidth:60 }}>{r.l}</span><span style={{ fontSize:13,color:w.text }}>{r.v}</span></div>)}
            </div>
          : <p style={{ fontSize:14,color:w.text,margin:0 }}>{todayEntry.reading||todayEntry.ot}</p>
        )}
      </Card>

      <Card>
        <h3 style={{ fontSize:14,fontWeight:500,color:w.text,margin:"0 0 12px" }}>Browse readings</h3>
        <div style={{ display:"flex",gap:8,marginBottom:12,alignItems:"center" }}>
          <button onClick={()=>setViewDay(d=>Math.max(1,d-1))} style={{ padding:"4px 10px",borderRadius:6,border:`0.5px solid ${w.border}`,background:"transparent",cursor:"pointer",color:w.text2 }}>←</button>
          <span style={{ flex:1,textAlign:"center",fontSize:13,color:w.text }}>Day {viewDay}</span>
          <button onClick={()=>setViewDay(d=>Math.min(totalDays,d+1))} style={{ padding:"4px 10px",borderRadius:6,border:`0.5px solid ${w.border}`,background:"transparent",cursor:"pointer",color:w.text2 }}>→</button>
        </div>
        {viewEntry&&(
          <div style={{ background:w.bg2,borderRadius:8,padding:"12px 14px" }}>
            {completed.includes(viewDay)&&<p style={{ fontSize:12,color:"#057A55",margin:"0 0 8px" }}>✓ Completed</p>}
            {planId==="oneyear"
              ? <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
                  {[{l:"OT",v:viewEntry.ot},{l:"NT",v:viewEntry.nt},{l:"Psalm",v:viewEntry.ps},{l:"Proverbs",v:viewEntry.prov}].map(r=><div key={r.l} style={{ display:"flex",gap:8 }}><span style={{ fontSize:12,color:plan.color,fontWeight:500,minWidth:60 }}>{r.l}</span><span style={{ fontSize:13,color:w.text }}>{r.v}</span></div>)}
                </div>
              : <p style={{ fontSize:14,color:w.text,margin:0 }}>{viewEntry.reading||viewEntry.ot}</p>
            }
            {!completed.includes(viewDay)&&<button onClick={()=>onMark(viewDay)} style={{ marginTop:10,fontSize:12,padding:"6px 14px",borderRadius:20,border:"none",background:plan.color,color:"#fff",cursor:"pointer" }}>Mark as read</button>}
          </div>
        )}
      </Card>
    </div>
  );
}

export default function BiblePlanModule({ moduleData, onSave, onBack, userName }) {
  const [view, setView] = useState("home");
  const [selectedPlan, setSelectedPlan] = useState(moduleData?.activePlan||null);
  const progress = moduleData?.progress||{};

  const choosePlan = planId => {
    onSave({ ...moduleData, activePlan:planId, progress:{ ...progress, [planId]:progress[planId]||{completed:[]} } });
    setSelectedPlan(planId); setView("plan");
  };

  const markRead = day => {
    const planProgress = progress[selectedPlan]||{completed:[]};
    const completed = planProgress.completed.includes(day) ? planProgress.completed.filter(d=>d!==day) : [...planProgress.completed,day];
    onSave({ ...moduleData, activePlan:selectedPlan, progress:{ ...progress, [selectedPlan]:{ ...planProgress, completed } } });
  };

  if(view==="plan"&&selectedPlan) return <PlanView planId={selectedPlan} progress={progress[selectedPlan]} onMark={markRead} onBack={()=>setView("home")} userName={userName} />;

  return (
    <div>
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back to Modules</button>
      <div style={{ display:"flex",alignItems:"center",gap:12,marginBottom:8 }}>
        <div style={{ width:40,height:40,borderRadius:10,background:`${gold}20`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20 }}>📖</div>
        <div><h2 style={{ fontSize:18,fontWeight:500,margin:0,color:w.text }}>Bible Reading Plan</h2><p style={{ fontSize:13,color:w.text3,margin:0 }}>Choose your plan and track daily progress</p></div>
      </div>
      <p style={{ fontSize:13,color:w.text2,lineHeight:1.7,margin:"16px 0 20px" }}>Select a reading plan and mark each day as complete. Your streak and progress are tracked automatically.</p>
      {Object.values(PLANS).map(plan=>{
        const p=progress[plan.id]; const pct=p?Math.round((p.completed.length/plan.schedule.length)*100):0;
        const isActive=moduleData?.activePlan===plan.id;
        return (
          <div key={plan.id} style={{ background:w.bg,border:`0.5px solid ${isActive?plan.color:w.border}`,borderRadius:12,padding:"16px 20px",marginBottom:10,cursor:"pointer" }}
            onClick={()=>{setSelectedPlan(plan.id);setView("plan");}}
            onMouseEnter={e=>e.currentTarget.style.borderColor=plan.color}
            onMouseLeave={e=>e.currentTarget.style.borderColor=isActive?plan.color:w.border}>
            <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8 }}>
              <div>
                <h3 style={{ fontSize:15,fontWeight:500,color:w.text,margin:"0 0 4px" }}>{plan.label}</h3>
                <p style={{ fontSize:13,color:w.text2,margin:0,lineHeight:1.5 }}>{plan.description}</p>
              </div>
              {isActive&&<span style={{ fontSize:11,padding:"3px 10px",background:`${plan.color}15`,color:plan.color,borderRadius:20,fontWeight:500,flexShrink:0,marginLeft:12 }}>Active</span>}
            </div>
            {pct>0&&<><div style={{ height:4,background:w.bg3,borderRadius:2,margin:"10px 0 4px",overflow:"hidden" }}><div style={{ height:"100%",width:`${pct}%`,background:plan.color,borderRadius:2 }} /></div><p style={{ fontSize:11,color:plan.color,margin:0 }}>{pct}% complete</p></>}
            {!moduleData?.activePlan&&<button onClick={e=>{e.stopPropagation();choosePlan(plan.id);}} style={{ marginTop:10,fontSize:12,padding:"6px 14px",borderRadius:20,border:`0.5px solid ${plan.color}`,background:"transparent",color:plan.color,cursor:"pointer" }}>Start this plan</button>}
          </div>
        );
      })}
    </div>
  );
}
